// package: profile
// file: apigateway/profile/user_status.proto

import * as apigateway_profile_user_status_pb from "../../apigateway/profile/user_status_pb";
import * as profileservice_user_status_pb from "../../profileservice/user_status_pb";
export class UserStatusService {
  static serviceName = "profile.UserStatusService";
}
export namespace UserStatusService {
  export class GetUserStatus {
    static readonly methodName = "GetUserStatus";
    static readonly service = UserStatusService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_user_status_pb.GetUserStatusRequest;
    static readonly responseType = apigateway_profile_user_status_pb.UserStatusReply;
  }
  export class GetMyUserStatus {
    static readonly methodName = "GetMyUserStatus";
    static readonly service = UserStatusService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_user_status_pb.GetMyUserStatusRequest;
    static readonly responseType = apigateway_profile_user_status_pb.UserStatusReply;
  }
  export class UpdateUserStatus {
    static readonly methodName = "UpdateUserStatus";
    static readonly service = UserStatusService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_user_status_pb.UpdateUserStatusRequest;
    static readonly responseType = apigateway_profile_user_status_pb.UserStatusReply;
  }
  export class UpdateStopCustomize {
    static readonly methodName = "UpdateStopCustomize";
    static readonly service = UserStatusService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_user_status_pb.UpdateStopCustomizeRequest;
    static readonly responseType = apigateway_profile_user_status_pb.UserStatusReply;
  }
}
